import { render } from "./LinkookLiveSignin.vue?vue&type=template&id=b805c21e"
import script from "./LinkookLiveSignin.vue?vue&type=script&lang=js"
export * from "./LinkookLiveSignin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__